import 'preact/debug'
import { render } from "htm/preact"


import "./styles.css"
import Main from './main'

const pronoums = window.dataLayer[0]["Include Pronouns (optional):"]

if (pronoums && pronoums !== "")
	window.dataLayer[0]["First & Last Name"] += `(${pronoums})`

render(<Main/> ,document.getElementById("content"))
